$(document).ready(function(){

//---------------------------------------------------------------------------------------//
	
	//SCROLL TO TOP FUNCTIONALITY
	
    //Check to see if the window is top if not then display button
    $(window).scroll(function(){
        if ($(this).scrollTop() > 100) {
            $('#backTop').fadeIn();
        } else {
            $('#backTop').fadeOut();
        }
    });

    //Click event to scroll to top
    $(document).on ("click", "#backTop", function () {
        $('html, body').animate({scrollTop : 0},100);
        return false;
    });
    
    
    
 //---------------------------------------------------------------------------------------//
    
    //SIDEBAR MENU SHOW/HIDE FUNCTIONALITY
    
    
    $(document).on ("click", "#btn-menu", function () {
		$(".sidenav").toggleClass('colapsed');
		
		if($(".sidenav").hasClass("colapsed")){
			$(".nav-text").hide();
			$(".nav-text-sub").hide();

			$(".container-fluid").attr("style", "margin-left: 120px;");
		}else{
			$(".nav-text").show();
			$(".nav-text-sub").show();
			$(".container-fluid").attr("style", "margin-left: 395px;");
		}	
	});
	
	$(document).on ("click", "#navMenu", function () {
    	if(($(".sidenav").hasClass("colapsed"))){
    		$(".sidenav").toggleClass('colapsed');
    		$(".nav-text").show();
	    	$(".nav-text-sub").show();
	    	$(".container-fluid").attr("style", "margin-left: 395px;");
		}	
    });
	
	
	//---------------------------------------------------------------------------------------//
});